module.exports = __webpack_public_path__ + "img/symmetry-bad.e3b29186.svg";